import type {
  CreateBreakApiQuery,
  CreatePatientBreakApiQuery,
  BreaksApiQuery,
  BreakApi,
  SummaryBreaksApi,
} from "@/Modules/Breaks/Models/Api";
import { OrderingParams } from "@/Modules/Breaks/Models/Api";

import { get2, post2, remove2 } from "./utils/FunctionalTherapyApi";

export async function getBreaks(uuid: string): Promise<BreakApi[]> {
  return get2<BreaksApiQuery, BreakApi[]>(`/v1.0/breaks/`, {
    customer_uuid: uuid,
    ordering: `-${OrderingParams.START_AT}`,
  });
}

export async function getSummaryBreaks(uuid: string): Promise<SummaryBreaksApi> {
  return get2<void, SummaryBreaksApi>(`/v1.0/clients/${uuid}/breaks`);
}

export function deleteBreak(breakUuid: string): Promise<void> {
  return remove2<void, void>(`/v1.0/breaks/${breakUuid}`);
}

export function deletePatientBreak(uuid: string, breakUuid: string): Promise<void> {
  return remove2<void, void>(`/v1.0/clients/${uuid}/breaks/${breakUuid}`);
}

export async function createBreak(breakData: CreateBreakApiQuery): Promise<BreakApi> {
  return post2<CreateBreakApiQuery, BreakApi>(`/v1.0/breaks`, breakData);
}

export async function createPatientBreak(
  uuid: string,
  breakData: CreatePatientBreakApiQuery
): Promise<BreakApi> {
  return post2<CreatePatientBreakApiQuery, BreakApi>(`/v1.0/clients/${uuid}/breaks`, breakData);
}
